import { Loader2 } from "lucide-react";
import { useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useDeleteMappingData } from "../../api/drawingTool";
import { Button } from "../../components/ui/common/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from "../../components/ui/common/dialog";
import { Input } from "../../components/ui/common/input";
import { MappingSourceType } from "../../config/enums/MappingSourceType.enum";
import {
  mappingDialogBodyClass,
  mappingDialogContentClass,
  mappingDialogFooterClass,
  mappingDialogHeaderClass,
  mappingDialogLoadingOverlayClass
} from "./mappingModalStyles";

const DeleteMappingModal = ({
  selectionData,
  sourceId,
  closeModal = () => {},
  drawingId,
  mappingSourceType
}: any) => {
  const [deleteText, setDeleteText] = useState("");
  const [isError, setIsError] = useState(false);
  const [searchParams] = useSearchParams();

  const { mutate, isLoading } = useDeleteMappingData(mappingSourceType);

  const mappingName = useMemo(() => {
    if (mappingSourceType === MappingSourceType.product) {
      return selectionData.find((item: any) => item.value === sourceId).text;
    }

    if (mappingSourceType === MappingSourceType.ingredient) {
      return searchParams.get("ingredientName");
    }

    return "";
  }, [selectionData, sourceId, drawingId, mappingSourceType]);

  const deleteMapping = () => {
    if (deleteText !== mappingName) {
      setIsError(true);
      return;
    }
    mutate(drawingId, {
      onSettled: () => {
        closeModal(true);
      }
    });
  };

  return (
    <Dialog open onOpenChange={open => !open && closeModal()}>
      <DialogContent className={mappingDialogContentClass}>
        <DialogHeader className={mappingDialogHeaderClass}>
          <DialogTitle>Delete Mapping!</DialogTitle>
        </DialogHeader>

        <div className={mappingDialogBodyClass}>
          {isLoading ? (
            <div className={mappingDialogLoadingOverlayClass}>
              <Loader2 className="tw-h-6 tw-w-6 tw-animate-spin tw-text-primary" />
            </div>
          ) : null}

          <Input
            value={deleteText}
            onChange={e => {
              setDeleteText(e.target.value);
              setIsError(false);
            }}
          />
          {isError ? (
            <p className="tw-m-0 tw-text-sm tw-text-destructive">
              Please type the correct mapping item name to delete.
            </p>
          ) : null}
          <p className="tw-m-0 tw-text-sm tw-text-muted-foreground">
            Please type delete mapping item name :- <i>{mappingName}</i>
          </p>
        </div>

        <DialogFooter className={mappingDialogFooterClass}>
          <Button type="button" variant="outline" disabled={isLoading} onClick={() => closeModal()}>
            Cancel
          </Button>
          <Button type="button" variant="destructive" disabled={isLoading} onClick={() => deleteMapping()}>
            Delete
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteMappingModal;
